/**
 * Consistent role badge used everywhere admins and editors surface in a
 * user list. Renders nothing for viewers/customers so the visual noise
 * only appears on internal staff.
 */
import React from 'react';
import { ShieldCheck, Pencil } from 'lucide-react';
import { Badge } from '../ui/badge';

const ROLE_CONFIG = {
  admin: {
    label: 'Admin',
    className: 'bg-primary/10 text-primary border-primary/40',
    icon: ShieldCheck,
    tooltip: 'Blayzrr staff · full admin access',
  },
  editor: {
    label: 'Editor',
    className: 'bg-amber-500/10 text-amber-700 border-amber-500/40 dark:text-amber-300',
    icon: Pencil,
    tooltip: 'Blayzrr staff · editor role',
  },
};

export function RoleBadge({ role, size = 'sm', className = '' }) {
  const cfg = ROLE_CONFIG[role];
  if (!cfg) return null; // viewers get no badge (they are the default)
  const Icon = cfg.icon;
  const sizeCls = size === 'xs' ? 'text-[9px] px-1.5 py-0' : 'text-[10px] px-2 py-0.5';
  return (
    <Badge
      variant="outline"
      title={cfg.tooltip}
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center gap-1 uppercase tracking-wider font-mono-edge ${sizeCls} ${cfg.className} ${className}`}
    >
      <Icon size={9} strokeWidth={2.5} />
      {cfg.label}
    </Badge>
  );
}

export default RoleBadge;
